import { useContext, useState } from 'react';
import { useCallback } from 'react';
import { HimmaContext } from '../context/HimmaContext';

export const useCategoryApi = () => {
  const api = useContext(HimmaContext)!;
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const getAllCategory = useCallback(
    async (query: any) => {
      console.log('query called category', query);
      setLoading(true);
      setError(null);
      try {
        const response = await api.getAllRestaurantCategories(query.storeType);
        return response.data;
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [api]
  );

  return {
    getAllCategory,
    loading,
    error,
  };
};
